import { render, staticRenderFns } from "./PopularList.vue?vue&type=template&id=454607e8&"
import script from "./PopularList.vue?vue&type=script&lang=js&"
export * from "./PopularList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/hanmail/src/cafe-top/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('454607e8', component.options)
    } else {
      api.reload('454607e8', component.options)
    }
    module.hot.accept("./PopularList.vue?vue&type=template&id=454607e8&", function () {
      api.rerender('454607e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/home/PopularList.vue"
export default component.exports